import {
  WhereaboutsCheckApiFactory,
  WhereaboutsCheckStatusResponse,
} from '@/repository/manager/whereaboutsCheck/openapi/generated';
import { AxiosInstance, AxiosError } from 'axios';
import { ErrorPresenter } from '@/repository/errorPresenter/types';

export default function (axios: AxiosInstance) {
  const api = WhereaboutsCheckApiFactory(undefined, undefined, axios);
  return (errorPresenter: ErrorPresenter): WhereaboutsCheckStatusRepository =>
    async () => {
      try {
        const { data } = await api.getWhereaboutsCheckStatus();
        return adapt(data);
      } catch (e: unknown) {
        const err = e as AxiosError;
        errorPresenter({ status: err.response?.status, error: err, requestUrl: err.config?.url });
        throw err;
      }
    };
}

const adapt = (data: WhereaboutsCheckStatusResponse): WhereaboutsCheckStatus => {
  return {
    isOutage: data.isOutage,
    isOutageParentNotification: data.isOutageParentNotification,
    isDeliveryLimitExceeded: data.isDeliveryLimitExceeded,
    serviceStatus: data.status,
    lastUpdatedAt: new Date(data.lastUpdatedAt),
    latestVersion: data.latestVersion,
    secondsUntilNextUpdate: data.secondsUntilNextUpdate,
  };
};
